import Image from 'next/image';
import { useIntl } from 'react-intl';

import { Typography } from '../../../../design-system/components/typography/Typography';
import { imageLoaderForPath } from '../../../../domains/Layout/Image/URL/ImageURL';

import style from './FamilyReassuranceStats.module.css';

type Props = {
    showLogo?: boolean;
};

export function FamilyReassuranceStats({ showLogo = false }: Props) {
    const { formatMessage } = useIntl();

    return (
        <div className={style.statsWrapper}>
            {showLogo ? (
                <div className={style.logoWrapper}>
                    <Image
                        loader={imageLoaderForPath}
                        src="/logos/evaneos-family.png"
                        width={137}
                        height={40}
                        alt="Evaneos Family logo"
                    />
                </div>
            ) : null}
            <div className={style.stat}>
                <Typography scale="secondary-s-bold" className={style.statTitle}>
                    {formatMessage({
                        id: 'page.itinerary.familyReassurance.modal.stat1.title',
                    })}
                </Typography>
                <Typography scale="primary-xs-regular">
                    {formatMessage({
                        id: 'page.itinerary.familyReassurance.modal.stat1.description',
                    })}
                </Typography>
            </div>
            <div className={style.stat}>
                <Typography scale="secondary-s-bold" className={style.statTitle}>
                    {formatMessage({
                        id: 'page.itinerary.familyReassurance.modal.stat2.title',
                    })}
                </Typography>
                <Typography scale="primary-xs-regular">
                    {formatMessage({
                        id: 'page.itinerary.familyReassurance.modal.stat2.description',
                    })}
                </Typography>
            </div>
            <div className={style.stat}>
                <Typography scale="secondary-s-bold" className={style.statTitle}>
                    {formatMessage({
                        id: 'page.itinerary.familyReassurance.modal.stat3.title',
                    })}
                </Typography>
                <Typography scale="primary-xs-regular">
                    {formatMessage({
                        id: 'page.itinerary.familyReassurance.modal.stat3.description',
                    })}
                </Typography>
            </div>
        </div>
    );
}
